class TranslationStore {
  multipleItems: Record<string, boolean>;

  constructor(multipleItems: Record<string, boolean> = {}) {
    this.multipleItems = multipleItems
  }
}
export {TranslationStore}
